import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * Dock Tab Component
 * 
 * Individual tab wrapper that contains panel content.
 * Visibility controlled by parent dock-tab-group.
 */
@customElement('dock-tab')
export class DockTab extends LitElement {
  static styles = css`
    :host {
      display: none;
      flex-direction: column;
      height: 100%;
      min-height: 0;
      overflow: hidden;
    }

    :host([active]) {
      display: flex;
    }

    .tab-wrapper {
      flex: 1;
      display: flex;
      flex-direction: column;
      min-height: 0;
      overflow: hidden;
    }

    ::slotted(*) {
      flex: 1;
      min-height: 0;
    }
  `;

  @property({ type: String, attribute: 'tab-id' }) tabId = '';
  @property({ type: String }) title = '';
  @property({ type: Boolean, reflect: true }) active = false;
  @property({ type: Boolean }) detachable = false;

  render() {
    return html`
      <div class="tab-wrapper">
        <slot></slot>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'dock-tab': DockTab;
  }
}
